<template>
  <div class="iDalgo-Login-Main-Form-Container">
    <!-- Back to classical login form -->
    <ida-button class="iDalgo-Login-Main-Redirect" color="#AFAFAF" height="50" round @click="$router.push({ name: 'login', query: $route.query })">
      <svgicon name="arrow-return" color="#FFF" width="16" />
      <span class="iDalgo-Login-Main-Redirect-Text">{{ $t('loginForm.back') }}</span>
    </ida-button>

    <h1 class="iDalgo-Login-Main-Title" :style="loginMainTitle">
      <span class="iDalgo-Login-Main-Title-Icon" :style="loginMainTitleIcon">
        <i :class="`ida-icon-${product}`"></i>
      </span>
      {{ $t(`products.${product}.title`) }}
    </h1>

    <el-form class="iDalgo-Login-Main-Form" :model="credentials" :rules="rules" @keydown.enter.native="handleConnectSSO">
      <el-form-item class="iDalgo-Login-Main-Form-ID" :label="$t('loginForm.ID.labelSSO')" prop="username">
        <el-input class="iDalgo-Login-Main-Form-ID-Input"
          v-model="credentials.username"
          :placeholder="$t('loginForm.ID.placeholder')" />
      </el-form-item>

      <el-form-item class="iDalgo-Login-Main-Form-Submit">
        <ida-button class="iDalgo-Login-Main-Form-Submit-Button" round color="#2E3545" height="50" :loading="loading" @click="handleConnectSSO">
          <span class="iDalgo-Login-Main-Form-Submit-Button-Text">{{ $t('loginForm.connectSSO') }}</span>
          <svgicon name="key" color="#FFF" width="16" />
        </ida-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import '@/components/icons'
import { mapGetters } from 'vuex'
import styles from '@/assets/styles/styles.scss'

export default {
  name: 'iDalgo-Login-Form-SSO',
  data () {
    return {
      credentials: {
        username: ''
      },
      rules: {
        username: [
          { required: true, message: this.$t('loginForm.rules.username.empty'), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      product: 'product/product',
      loading: 'auth/loading'
    }),
    loginMainTitle () {
      return {
        color: this.mainColor
      }
    },
    loginMainTitleIcon () {
      return {
        backgroundColor: this.mainColor
      }
    },
    mainColor () {
      return styles[`${this.product}Color`]
    }
  },
  methods: {
    handleConnectSSO (e) {
      e.preventDefault()
      this.$store.dispatch('auth/loginWithSSO', this.credentials)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/iDalgo-Login-Form-SSO.vue